<app-base-sidebar>
  <router-outlet />
</app-base-sidebar>
